import React, { FunctionComponent, useState } from 'react';
import classNames from 'classnames';
import Image from 'react-retina-image';

import styles from './MenuItem.module.scss';
import { BRAND } from '../../constants/brand';
import { Heading, Hidden } from '../index';

interface MenuItemProps {
  className?: string;
  item: any;
  touch: boolean;
  mirror?: boolean;
}

const ImageFlip = ({ images, name, touch, mirror = false }) => {
  const shouldFlip = !!images[1];

  const [flip, setFlip] = useState(false);

  const onClick = () => {
    if (!touch) return;
    setFlip(!flip);
  };

  const imageClassName = index =>
    classNames({
      [styles.image]: true,
      [styles.imageFront]: index === 0,
      [styles.imageBack]: index === 1 && !mirror,
      [styles.imageBackMirrored]: index === 1 && mirror,
    });

  const flipperClassName = classNames({
    [styles.imageFlipper]: shouldFlip,
  });

  const imageContainerClassName = classNames({
    [styles.imageContainer]: true,
    [styles.imageContainerTouch]: touch,
    [styles.imageContainerFlip]: flip,
  });

  return (
    <div
      role="presentation"
      className={imageContainerClassName}
      onClick={onClick}
    >
      <div className={flipperClassName}>
        {images.map((image, index) => (
          <Image
            src={`/images/menu/${image}.jpg`}
            alt={name}
            className={imageClassName(index)}
            key={image}
          />
        ))}
      </div>
    </div>
  );
};

const MenuItem: FunctionComponent<MenuItemProps> = ({
  className,
  item: { name, type, images, prices, description },
  touch,
  mirror = false,
}) => {
  const menuItemClass = classNames(
    `${BRAND.SUPER_SHORT_NAME}-menu-item`,
    className,
    {
      [styles.menuItem]: true,
    },
  );

  return (
    <li className={menuItemClass}>
      <ImageFlip images={images} name={name} touch={touch} mirror={mirror} />

      <Heading level={3} styledAs={4} className={styles.name}>
        {name}
      </Heading>

      {!!description && <div className={styles.description}>{description}</div>}

      <div className={styles.prices}>
        {prices.map((price, index) => (
          <span key={`${name}-${price}`} className={styles.price}>
            For {index + 1}
            <Hidden className={styles[`${type}${index === 1 ? 2 : ''}`]}>
              {type}
            </Hidden>
            £{price}
          </span>
        ))}
      </div>
    </li>
  );
};

export default MenuItem;
